module.exports = __webpack_public_path__ + "media/images/gallery/constellations/dn_layer_on-a1e3fa266025c3b60f870c7c3701b36e.jpg";